(function(){
  var data;
  var pending;
  var timer;
  function load(){
    if(data)return Promise.resolve(data);
    pending=pending||fetch('/collections/all?section_id=search-card-data').then(function(r){return r.text()}).then(function(html){
      var el=new DOMParser().parseFromString(html,'text/html').getElementById('tcs-search-data');
      data=el?JSON.parse(el.textContent):{};
      return data;
    }).catch(function(){data={};return data});
    return pending;
  }
  function esc(s){
    var d=document.createElement('div');
    d.textContent=s;
    return d.innerHTML;
  }
  function enhance(li){
    if(li.dataset.tcsCard)return;
    var link=li.querySelector('a[href*="/products/"]');
    var title=li.querySelector('.snize-title');
    if(!link||!title)return;
    var p=data[link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0]];
    if(!p)return;
    li.dataset.tcsCard='1';
    if(p.cap)title.insertAdjacentHTML('beforeend','<span class="tcs-sc-cap">'+esc(p.cap)+'</span>');
    var html='';
    if(p.insp)html+='<span class="tcs-sc-insp">'+esc(p.insp)+'</span>';
    if(p.notes.length)html+='<span class="tcs-sc-notes">'+p.notes.map(esc).join(' | ')+'</span>';
    title.insertAdjacentHTML('afterend',html);
  }
  function run(){
    var items=document.querySelectorAll('#snize-instant-search-results li.snize-product,#snize_results li.snize-product');
    if(!items.length)return;
    load().then(function(){items.forEach(enhance)});
  }
  document.addEventListener('focusin',function(e){
    if(e.target.matches&&e.target.matches('input[type="search"]'))load();
  });
  new MutationObserver(function(){
    clearTimeout(timer);
    timer=setTimeout(run,80);
  }).observe(document.body,{childList:true,subtree:true});
})();
